import { createContext } from 'react';

export type ToothState =
  | 'NORMAL'
  | 'MISSING'
  | 'IMPLANT'
  | 'PONTIC'
  | 'IMPACTED'
  | 'UNKNOWN';
export type Plaque = 'NONE' | 'SLIGHT' | 'MODERATE' | 'HEAVY' | 'UNKNOWN';
export type Mobility =
  | 'NONE'
  | 'CLASS_I'
  | 'CLASS_II'
  | 'CLASS_III'
  | 'UNKNOWN';
export type BoneLoss = 'NONE' | 'SLIGHT' | 'MODERATE' | 'SEVERE' | 'UNKNOWN';

export interface ToothSurfaceMeasurements {
  probingDepth: number | null;
  gingivalMargin: number | null;
  clinicalAttachmentLevel: number | null;
  hasBleeding: boolean | null;
  hasSuppuration: boolean | null;
  furcationGrade: number | null;
  mucogingivalJunction: number | null;
}

export interface ToothSurfaces {
  distal: ToothSurfaceMeasurements;
  center: ToothSurfaceMeasurements;
  mesial: ToothSurfaceMeasurements;
}

export interface PerioChartTooth {
  toothNumber: string | null;
  toothState?: ToothState | null;
  plaque?: Plaque | null;
  mobility?: Mobility | null;
  boneLoss?: BoneLoss | null;
  facialMeasurements?: ToothSurfaces | null;
  lingualMeasurements?: ToothSurfaces | null;
}

export interface PerioChartResponse {
  examDate: string | null;
  teeth: PerioChartTooth[];
}

export type Arch = 'upper' | 'lower';
export type ToothSide = 'facial' | 'lingual';
export type ToothSurface = keyof ToothSurfaces;
export type ToothSurfaceMeasurement = keyof ToothSurfaceMeasurements;

export const PerioChartModeContext = createContext<'light' | 'dark'>('dark');
